<bw-header-label-cell-legacy
  @fadeIn
  (clickEvent)="navigateToCreditDashboard()"
  [labelCellConfig]="creditCompleteCellConfig"
  [hasContent]="showRetryAccessory"
>
  @if (showRetryAccessory) {
  <bw-bui-tile-legacy tileMargin="0 0 8px 0" (bwClick)="creditCardContentAction()">
    @if (isApiError) {
      <bui-tile-card-legacy [cardBackground]="'var(--white)'" [cardBorder]="'1px solid var(--gray-10)'">
        <bw-bui-row-legacy [rightIconName]="'refresh'" rightIconColor="var(--secondary-text)">
          <div class="row-content">
            <bw-bui-column-legacy
              [rowSpacing]="4"
              [rows]="[
                { type: 'detail', content: 'ACCOUNT_ERROR_TITLE' | translate, color: 'var(--primary-text)' },
                { type: 'label', content: 'ACCOUNT_ERROR_DESC' | translate, color: 'var(--secondary-text)' }
              ]"
            ></bw-bui-column-legacy>
          </div>
        </bw-bui-row-legacy>
      </bui-tile-card-legacy>
    } @else {
      <div class="center pointer">
        <typography-legacy text-small-regular color="var(--disabled-text)">
          <u>
            {{ 'CONNECT_CREDIT_SEGMENT_TITLE' | translate }}
          </u>
        </typography-legacy>
      </div>
    }
  </bw-bui-tile-legacy>
  }
</bw-header-label-cell-legacy>

@if (vantageVisible) {
<bw-modal-legacy modalWidth="medium" [brightsideWebFb]="{ event_name: 'credit_vantage_modal_shown' }">
  <typography-legacy title-medium>{{ 'CREDIT_VANTAGESCORE_ABOUT' | translate }}</typography-legacy>
  <typography-legacy
    [innerHTML]="'CREDIT_VANTAGESCORE_INFO' | translate"
    class="body mb-md"
    text-large-regular
    color="var(--secondary-text)"
  >
  </typography-legacy>
  <div class="footer flex-row row-reverse">
    <button
      bw-button-legacy
      (click)="vantageVisible = false"
      [brightsideWebFb]="{ event_name: 'credit_vantage_modal_dismissed', action: 'click' }"
      [dismissedCta]="true"
    >
      <typography-legacy text-large-semibold>{{ 'OK' | translate }}</typography-legacy>
    </button>
  </div>
</bw-modal-legacy>
}
